import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Page,
  DealStatusSelect,
  DealCloseDate,
} from '../shared';

import ReactTooltip from 'react-tooltip';

import {
  formatThousands,
  getDealCompletion,
  getClassModifierForConfidence,
  getDealItemsAtRisk,
  dealAmountAsString,
  dealValueInUSD,
} from '../../util';

import {
  syncSalesforceData,
} from '../../actions/integrations/salesforce';

import{
  getIcon
} from '../../util/icons';

import {
  IntegrationSelector
} from '../../selectors';

import {
  ConfirmModal,
  UpdateDealModal,
  CreateSalesforceDealModal,
} from '../modals';

import { fetchDealsForEmployee } from '../../actions/deals';

import { Redirect, Link } from 'react-router-dom';

class ImperativesPage extends Component {

  state = {
    pageMessage: null,
    updatingDeal: null,
    creatingSalesforceDeal: null,
    linkingSalesforceDeal: null,
    redirectingToDeal: false,
    filterByStatus: 'open',
    startingDeal: null,
    refreshingIntegrationData: false,
    ignoreDefaultReadyToStartDealsFilter: false
  }

  employeeIdFromParams(){
    const { match: { params } } = this.props;
    let employeeId = params.employeeId;

    return employeeId || null;
  }

  componentWillMount(){
    let employeeId = this.employeeIdFromParams();

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(employeeId){
      this.setState({
        employeeId,
        isOwnDeals: false,
      });
    }
    else{
      employeeId = this.props.user.uid;

      this.setState({
        employeeId,
        isOwnDeals: true,
      });
    }

    this.reloadDeals(employeeId);
  }

  reloadDeals(employeeId){
    this.props.fetchDealsForEmployee(employeeId || this.state.employeeId);
  }

  renderDealSource(source){
    return (
      <div className="deal-source salesforce">{getIcon('salesforce')}</div>
    );
  }

  showStartDeal(deal){
    this.setState({
      startingDeal: deal
    });
  }

  renderDeal(deal){

    const { _id, name, status, estimatedValue, estimatedCloseDate, completion, itemsAtRisk, userId, source } = deal;
    const employeeId = this.employeeIdFromParams();

    if(!_id){
      return null;
    }

    const dealLink = employeeId ? `/people/${employeeId}/imperatives/${_id}` : `/imperatives/${_id}`;

    const { confidence } = (completion || {});

    const dealConfidenceClassModifier = getClassModifierForConfidence(confidence);

    const dealIsActive = completion.active;

    if(dealIsActive){
      return (
        <Link key={_id} to={dealLink} className="deal-wrap">
          <li className="deal fs-block actionable">
            {source && this.renderDealSource(source)}
            <div className="deal-name">{name}</div>
            <div className="deal-primary-info">{dealAmountAsString(deal)}</div>

            {status === 'open' &&
              <div className="deal-secondary-info"><DealCloseDate deal={deal} /></div>
            }
            {status === 'won' &&
              <div className="deal-secondary-info">Won on <DealCloseDate deal={deal} /></div>
            }
            {status === 'lost' &&
              <div className="deal-secondary-info">Lost</div>
            }

            {status === 'open' && itemsAtRisk && itemsAtRisk.length > 0 &&
              <React.Fragment>
                <div data-for={`deal-${_id}-items-at-risk-count-tooltip`} data-tip={`Deal has ${itemsAtRisk.length} item${itemsAtRisk.length !== 1 ? 's' : ''} at risk`} className="deal-at-risk">{getIcon('warning')}<div className="count">{itemsAtRisk.length}</div></div>
                <ReactTooltip id={`deal-${_id}-items-at-risk-count-tooltip`} effect="solid" place="top" />
              </React.Fragment>
            }
            {status === 'open' &&
              <div className="deal-confidence-label">
                <div className={`dial confidence-${dealConfidenceClassModifier}`} style={{width: '60px', height: '60px'}}>
                  <div className="dial__progress" data-percent={confidence}></div>
                  <div className="dial__content" style={{lineHeight: '50px'}}>{confidence}</div>
                  <div className="dial__denominator">/100</div>
                </div>
              </div>
            }
            {status === 'won' &&
              <div onClick={() => { this.showStartDeal(deal); }} className="deal-view-button">VIEW</div>
            }
            {status === 'lost' &&
              <div onClick={() => { this.showStartDeal(deal); }} className="deal-view-button">VIEW</div>
            }
          </li>
        </Link>
      )
    }
    else{
      return (
        <div className="deal-wrap" key={_id}>
          <li className="deal fs-block">
            {source && this.renderDealSource(source)}
            <div className="deal-name">{name}</div>
            <div className="deal-primary-info">{dealAmountAsString(deal)}</div>
            <div className="deal-secondary-info">{moment(estimatedCloseDate).format('MM/DD/YY')}</div>

            {!dealIsActive &&
              <div onClick={() => { this.showStartDeal(deal); }} className="deal-start-button">START</div>
            }
          </li>
        </div>
      )
    }
  }

  allDeals(){
    const { deals } = this.props || [];

    return _.map(deals, deal => {

      const completion = getDealCompletion(deal);
      const itemsAtRisk = getDealItemsAtRisk(deal);

      return {
        ...deal,
        completion,
        itemsAtRisk,
      }
    });
  }

  dealsForView(){
    const { filterByStatus } = this.state;
    const filteredDeals = _.filter(this.allDeals(), { status: filterByStatus });

    return filteredDeals;
  }

  renderDeals(){

    const deals = this.dealsForView();
    const {
      filterByStatus,
      ignoreDefaultReadyToStartDealsFilter
    } = this.state;

    const activeDeals = _.filter(deals, deal => {
      return deal.completion.active;
    });

    const readyToStartDeals = _.filter(deals, deal => {
      return !deal.completion.active && deal.status === 'open';
    });

    const filteredReadyToStartDeals = _.filter(readyToStartDeals, deal => {

      //if ignoring default filter
      if(ignoreDefaultReadyToStartDealsFilter){
        return true;
      }

      const defaultFilters = (((this.props.organization || {}).integrations || {}).salesforce || {}).defaultFilters;

      if(defaultFilters){

        const {
          amount
        } = defaultFilters;

        if(amount && amount > 0){
          return dealValueInUSD(deal) >= amount;
        }
        //TODO support more filters
      }

      //by default, deals match
      return true;
    });

    const hiddenByFilterReadyToStartDeals = readyToStartDeals.length - filteredReadyToStartDeals.length;

    const actionRequiredDeals = _.filter(this.allDeals(), deal => {
      return deal.completion.active && (deal.status === 'won' || deal.status === 'lost') && !deal.closeStatusProgressVerified;
    });

    return(
      <div className="page-content">
        <div className="page-section">
          <ul className="deals-list">
            {_.map(activeDeals, this.renderDeal.bind(this))}
          </ul>
          {actionRequiredDeals.length > 0 &&
            <ul className="deals-list">
              <h6>VERIFICATION NEEDED</h6><span></span>
              {_.map(actionRequiredDeals, this.renderDeal.bind(this))}
            </ul>
          }
          {filterByStatus === 'open' && readyToStartDeals.length > 0 &&
            <ul className="deals-list">
              <h6>READY TO START</h6><span></span>
              {_.map(filteredReadyToStartDeals, this.renderDeal.bind(this))}
            </ul>
          }
          {filterByStatus === 'open' && hiddenByFilterReadyToStartDeals > 0 &&
            <p className="footnote">{hiddenByFilterReadyToStartDeals} deal{hiddenByFilterReadyToStartDeals === 1 ? '' : 's'} not shown due to filters.<br/><span onClick={() => { this.setState({ ignoreDefaultReadyToStartDealsFilter: true }); }} className="action">Show All Deals</span></p>
          }
        </div>
      </div>
    )
  }

  beginUpdatingDeal(deal){
    this.setState({
      updatingDeal: { ...deal }
    });
  }

  beginAddingNewDeal(){

    const newDeal = {
      userId: this.state.employeeId,
      status: 'open',
      stage: 'open',//TODO figure out how to implement this from
      estimatedCloseDate: moment().valueOf(),
    };

    if(this.props.integration === 'salesforce'){
      this.setState({
        creatingSalesforceDeal: newDeal
      });
    }
    else{
      this.setState({
        updatingDeal: newDeal
      });
    }
  }

  afterDealUpdate(deal){
    this.reloadDeals();

    this.setState({
      updatingDeal: null
    });
  }
  afterDealCreate(deal){
    this.reloadDeals();

    this.setState({
      creatingSalesforceDeal: null,
      updatingDeal: null,
      redirectingToDeal: deal._id
    });
  }

  renderDealStatusSelect(){
    return(
      <DealStatusSelect
        value={this.state.filterByStatus}
        onUpdate={newStatus => { this.setState({ filterByStatus: newStatus }); }}
      />
    )
  }

  renderDealsPageTitle(){

    const { filterByStatus } = this.state;

    const { viewingUser, deals } = this.props;

    if(!deals){
      return;
    }

    const dealTotalToDisplay = _.reduce(deals, (memo, deal) => {
      return memo + (deal.status === filterByStatus ? deal.estimatedValue : 0);
    }, 0);

    const dealTotalLabel = filterByStatus === 'open' ? 'in pipeline' : (filterByStatus === 'won' ? 'in won deals' : 'in lost deals');

    let dealOwnersName = 'My';

    if(viewingUser){
      dealOwnersName = `${viewingUser.firstName}'s`;
    }

    return(
      <div className="page-title">
        <h1>{dealOwnersName} {filterByStatus.substring(0,1).toUpperCase() + filterByStatus.substring(1)} Deals</h1>
        {dealTotalToDisplay > 0 &&
          <h3 className="fs-block">${formatThousands(dealTotalToDisplay)} {dealTotalLabel}</h3>
        }
      </div>
    )
  }

  refreshIntegrationData(){
    if(this.state.refreshingIntegrationData){ return; }

    this.setState({ refreshingIntegrationData: true });

    syncSalesforceData(() => {
      this.setState({ refreshingIntegrationData: false });
      this.reloadDeals();
    });
  }

  render(){

    const { redirectingToDeal, employeeId, refreshingIntegrationData } = this.state;

    if(redirectingToDeal){
      const redirectToUrl = `${this.state.isOwnDeals ? `` : `/people/${employeeId}`}/imperatives/${redirectingToDeal}`;
      return <Redirect to={redirectToUrl} />
    }

    const loading = !this.props.user || this.props.loadingDeals;

    const { viewingUser } = this.props;

    return (
      <Page
        pageClass="imperatives"
        loading={loading}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderDealsPageTitle()}
        <div className="page-actions">
          {this.props.integration === 'salesforce' && this.props.organization.integrationDealCreationEnabled &&
            <button
              onClick={this.beginAddingNewDeal.bind(this)}
              className="button salesforce-button">{getIcon('salesforce-outline', 'button-badge')}Add new deal{!this.state.isOwnDeals && ` for ${(viewingUser || {}).firstName}`}</button>
          }
          {!this.props.integration &&
            <button
              onClick={this.beginAddingNewDeal.bind(this)}
              className="button primary">Add new deal{!this.state.isOwnDeals && ` for ${(viewingUser || {}).firstName}`}</button>
          }
          {this.props.integration === 'salesforce' &&
            <React.Fragment>
              <div data-for="refresh-integration-data-tooltip" data-tip="Reload deals" onClick={this.refreshIntegrationData.bind(this)} className={`action ${refreshingIntegrationData ? 'spinning disabled' : ''}`}>{getIcon(refreshingIntegrationData ? 'refresh' : 'sync')}</div>
              {!refreshingIntegrationData &&
                <ReactTooltip id="refresh-integration-data-tooltip" effect="solid" place="top"/>
              }
            </React.Fragment>
          }
          {this.renderDealStatusSelect()}
        </div>
        {this.renderDeals()}
        <CreateSalesforceDealModal
          hide={() => { this.setState({ creatingSalesforceDeal: null }); }}
          editingDeal={this.state.creatingSalesforceDeal}
          visible={!!this.state.creatingSalesforceDeal}
          onCreate={this.afterDealCreate.bind(this)}
          viewingUser={viewingUser}
        />
        <UpdateDealModal
          hide={() => { this.setState({ updatingDeal: null }); }}
          editingDeal={this.state.updatingDeal}
          visible={!!this.state.updatingDeal}
          onCreate={this.afterDealCreate.bind(this)}
          onUpdate={this.afterDealUpdate.bind(this)}
          viewingUser={viewingUser}
        />
      <ConfirmModal
        iconKey='insight'
        buttonClass="blue-button"
        confirmText='Get Started'
        cancelText="Nevermind"
        message={`Once started, deal progress will be used in forecasting and insight generation.`}
        onConfirm={() => { this.setState({ redirectingToDeal: this.state.startingDeal._id }); }}
        hide={() => { this.setState({ startingDeal: null }); } }
        visible={this.state.startingDeal}
        />
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    loadingDeals: state.deals.loading,
    deals: state.deals.data,
    organization: state.organization.data,
    viewingUser: state.viewingUser.data,
    integration: IntegrationSelector(state),
  }
}

export default connect(mapStateToProps, { fetchDealsForEmployee })(ImperativesPage);



// WEBPACK FOOTER //
// ./src/components/imperatives/index.js